import { useState, useEffect } from 'react';
import logoService from '../services/logoService';

const DEFAULT_ICON = '/assets/images/crc_logo_dia_logo_500-1759554868300.png';
const DEFAULT_TEXT = '/assets/images/crc_logo_dia_text_500-1759554658424.png';

let cachedSettings = null;
let cacheTime = 0;
const CACHE_TTL = 60000; // 1 minute

export const useLogoSettings = () => {
  const [logoIcon, setLogoIcon] = useState(DEFAULT_ICON);
  const [logoText, setLogoText] = useState(DEFAULT_TEXT);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const now = Date.now();
        if (cachedSettings && now - cacheTime < CACHE_TTL) {
          setLogoIcon(cachedSettings?.logo_icon_url || DEFAULT_ICON);
          setLogoText(cachedSettings?.logo_text_url || DEFAULT_TEXT);
          setLoaded(true);
          return;
        }

        const { data } = await logoService?.getLogoSettings();
        if (data) {
          cachedSettings = data;
          cacheTime = now;
          setLogoIcon(data?.logo_icon_url || DEFAULT_ICON);
          setLogoText(data?.logo_text_url || DEFAULT_TEXT);
        }
      } catch {
        // Fall back to defaults silently
      } finally {
        setLoaded(true);
      }
    };

    fetchLogo();
  }, []);

  return { logoIcon, logoText, loaded };
};
